import axios from 'axios'

const publicInstance = (token) => 
    axios.create({
        // We need site URL for login instead of server URL.
        baseURL: ""+ process.env.REACT_APP_PUBLIC_API_URL +"",
        headers: {  "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
                    "Access-Control-Allow-Methods": "GET,POST",
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
        crossDomain: true,
        mode: 'CORS'
    });

export default publicInstance;
